import { ReactComponent as DownArrow } from 'assets/downarrow.svg';
import { ReactComponent as UpArrow } from 'assets/uparrow.svg';
import { useCallback, useContext } from 'react';
import { order, initialFilters, tipoDocFilter } from 'pools/filterPool';
import './styles.scss';
import { GlobalContext } from 'Context/GlobalContext/AppContext';

const Filter = ({ filters = initialFilters, filter, setFilter, setPage }) => {
  const { user } = useContext(GlobalContext);

  const handleFilterClick = useCallback(
    (newFilter) => {
      setFilter((prevState) => ({ ...prevState, ...newFilter, Ordem: order[filter.Ordem] }));
      setPage(1);
    },
    [setFilter, setPage, filter.Ordem],
  );

  return (
    <section className="filterWrapper">
      <div className="filter">
        <div className="filter__leftArrow"></div>
        <div className="filter__rightArrow"></div>
        <div className="filter__items">
          {filters.map((newFilter) => {
            return (
              <div
                key={newFilter.Coluna}
                className={`filter__item ${newFilter.Coluna === 'NDownload' && !user.isAuthenticated ? 'filter__item--hidden' : ''}`}
                onClick={() => handleFilterClick(newFilter)}
              >
                {filter?.Coluna === newFilter.Coluna && (filter.Ordem === 'ASC' ? <UpArrow /> : <DownArrow />)}
                {newFilter.Text}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Filter;
